import React from "react";
import { Message } from "components/generic/layout";
import { Overlay } from "components/common/candidate";
import { compose, nest } from "recompose";
import * as hoc from "modules/user/auth/hoc";
import { isOnboardedCandidate } from "modules/user/auth/model";

const Success = () => (
  <Message
    title="Your call has been successfully cancelled!"
    text="You'll receive a confirmation soon. Check your email!"
    showIcon
  />
);
export default compose(hoc.authorized(isOnboardedCandidate))(
  nest(Overlay, Success)
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/CancelCallSuccess/index.js